import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { ModelEmsPayload, ModelEmsResponse } from '@/models/outbounds';

export class GlobalMailState {
  public ems: ModelEmsPayload = new ModelEmsPayload();
  public emsResponse: ModelEmsResponse = new ModelEmsResponse();
  public receptionTimePopup = false;
}

const Mutations: MutationTree<GlobalMailState> = {
  updateEms(state: GlobalMailState, payload: ModelEmsPayload) {
    state.ems = payload;
  },
  updateEmsResponse(state: GlobalMailState, payload: ModelEmsResponse) {
    state.emsResponse = payload;
  },
  updateReceptionTimePopup(state: GlobalMailState, payload: boolean) {
    state.receptionTimePopup = payload;
  },
};
const Actions: ActionTree<GlobalMailState, any> = {
  updateEms({ commit }, payload: ModelEmsPayload) {
    commit('updateEms', payload);
  },
  updateEmsResponse({ commit }, payload: ModelEmsResponse) {
    commit('updateEmsResponse', payload);
  },
  updateReceptionTimePopup({ commit }, payload: boolean) {
    commit('updateReceptionTimePopup', payload);
  },
};

const module: Module<GlobalMailState, any> = {
  namespaced: true,
  state: new GlobalMailState(),
  mutations: Mutations,
  actions: Actions,
};

export default module;
